:host {
  display: block;
  font-size: 16px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
}

* {
  box-sizing: border-box;
}

$family: 'San Francisco', -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', Avenir, 'Avenir Next', 'Helvetica Neue', 'Segoe UI', Helvetica, Arial, sans-serif;

a {
  color: #fff;
}

.overlay {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 48px;
  color: #fff;
  font-family: var(--plyr-font-family, $family);
  height: 100%;

  &:before {
    content: '';
    border-radius: var(--presto-player-border-radius, 0);
    opacity: var(--presto-player-email-background-opacity, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: var(--presto-player-email-background, #000);
    z-index: -1;
    box-shadow: inset 0 0 100px black;
  }

  &.rtl form {
    flex-direction: row-reverse;
  }
}

.content {
  width: 20em;
}

form {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

input {
  background: #fff;
  border: none;
  font-size: 0.8em;
  line-height: 20px;
  padding: 6px 8px;
  border-radius: 0;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  border-radius: var(--presto-player-email-border-radius, 0) 0 0 var(--presto-player-email-border-radius);
  flex: 1;

  @media screen and (min-width: 700px) {
    padding: 10px 14px;
  }

  &:focus {
    border-color: var(--plyr-color-main, #000);
    z-index: 1;
  }
  &:focus,
  &:hover {
    outline: none;
  }
}

.rtl input {
  border-radius: 0 var(--presto-player-email-border-radius, 0) var(--presto-player-email-border-radius) 0;
}

button {
  background-color: var(--presto-player-button-color, var(--plyr-color-main));
  border-color: var(--presto-player-button-color, var(--plyr-color-main));
  color: var(--presto-player-button-text, #fff);
  appearance: none;
  padding: 6px 12px;
  align-items: center;
  display: inline-flex;
  border-width: 1px;
  border-color: transparent;
  border-radius: 0;
  cursor: pointer;
  font-size: 0.8em;
  border-radius: 0 var(--presto-player-email-border-radius, 0) var(--presto-player-email-border-radius) 0;

  @media screen and (min-width: 700px) {
    padding: 10px 18px;
  }

  &:focus {
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px, var(--plyr-color-main, #000) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
    z-index: 1;
  }
  &:focus,
  &:hover {
    outline: none;
  }
}

.rtl button {
  border-radius: var(--presto-player-email-border-radius, 0) 0 0 var(--presto-player-email-border-radius);
}

h1 {
  font-size: 1.5em;
  font-weight: 500;
  margin: 0 0 22px 0;
  max-width: 600px;
  line-height: 1.1em;

  &.is-small {
    margin-bottom: 1em;
    font-size: 1.1em;
  }
}

.skip {
  font-size: 0.8em;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  padding: 4%;
  cursor: pointer;
}

p {
  font-size: 0.7em;
  margin: 0;
  margin-top: 1.5em;

  &.is-small {
    font-size: 0.9em;
    margin-top: 1em;
  }
}
